// extracted by mini-css-extract-plugin
export default {"container":"DropZone_container__VprjT"};